export type AbPattern = 'A' | 'B' | 'C' | 'D'

export interface PatternConfig {
    pattern: AbPattern
    percentage: number
}

/**
 * パスに加えて「この流入をテスト対象にするか」を絞り込むクエリ条件（DEV-3390）。
 * 値はデータで持つ（関数にしない）。settings.ts を「設定が並んでいるだけのファイル」に
 * 保ち、判定ロジックを core.ts 側に閉じ込めるため。
 */
export interface QueryTargeting {
    /** 見るクエリパラメータ名。例: 'mc' */
    param: string
    /** パラメータ値に対する条件。g フラグは付けないこと（lastIndex が残り test() の結果が交互に変わる） */
    pattern: RegExp
}

export interface AbTestConfig {
    issueNumber: string
    patterns: PatternConfig[]
    pathRegex: RegExp
    /**
     * 新規に割当を発行してよい流入の条件。未指定ならパスが一致する全流入が対象（従来どおり）。
     * これは「config が有効か」ではなく「新規参加の資格があるか」の条件である点に注意。
     * 詳細は core.ts の isTargetVisitor を参照。
     */
    targetQuery?: QueryTargeting
    isActive: boolean
}

export const DEFAULT_PATTERN: AbPattern = 'A'


